import type { dash_connectors } from "@dropbox/api-v2-client";
import { useSetConnectors } from "@mirage/shared/atoms/connectors";
import { useEffect, useState } from "react";

export const usePopulateAllAvailableConnectorsAtomData = ({
  isConnectorVisible,
  getCachedOrListConnectors,
}: {
  isConnectorVisible: (connector: dash_connectors.Connector) => boolean;
  getCachedOrListConnectors: () => Promise<dash_connectors.Connector[]>;
}) => {
  const setConnectors = useSetConnectors();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setConnectors((atom) => ({ ...atom, loading: true }));
    getCachedOrListConnectors()
      .then((allConnectors) => allConnectors.filter(isConnectorVisible))
      .then((visibleConnectors) =>
        setConnectors({
          data: visibleConnectors.map((c) => ({ ...c, loading: false })),
          loading: false,
          loaded: true,
        }),
      )
      .catch((e) => {
        setConnectors((atom) => ({ ...atom, loading: false }));
        setError(e as Error);
      });
  }, [setConnectors]);

  return { error };
};
